import styled from 'styled-components';

export const SwiperContainer = styled.div`
  overflow: hidden;
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
`;

export const SwiperTrack = styled.div<{ $offset: number }>`
  display: flex;
  transition: 0.3s ease-in-out;
  height: 100%;
  transform: translate3d(-${({ $offset }) => $offset}%, 0px, 0px);
`;

export const SwiperSlide = styled.div`
  flex: 0 0 100%;
  height: 100%;
  overflow: hidden;

  > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
`;
